import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE } from "../config/api";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();

  // 🔥 Signup se sirf email aata hai
  const { email } = location.state || {};

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // ❗ Agar email hi nahi hai → direct signup
  useEffect(() => {
    if (!email) {
      navigate("/signup");
    }
  }, [email, navigate]);

  const handleVerifyOtp = async () => {
    if (!otp) return alert("OTP required");

    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/api/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          otp: otp.trim(), // 🔥 MOST IMPORTANT FIX
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        return alert(data.message || "OTP verification failed");
      }

      alert("Account created successfully. Please login.");
      navigate("/login");

    } catch (err) {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center
      bg-gradient-to-br from-black via-gray-950 to-black text-white"
    >
      <div
        className="bg-gray-900/80 backdrop-blur
        p-8 rounded-2xl w-full max-w-md
        border border-gray-800 shadow-2xl"
      >
        <h2 className="text-2xl font-bold text-center mb-4">
          Verify OTP
        </h2>

        <p className="text-sm text-gray-400 text-center mb-6">
          OTP sent to <span className="text-white">{email}</span>
        </p>

        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="Enter 6-digit OTP"
          className="w-full p-3 mb-4 bg-gray-800 rounded-lg
          text-center tracking-widest outline-none"
          value={otp}
          onChange={(e) =>
            setOtp(e.target.value.replace(/\D/g, ""))
          }
        />

        <button
          disabled={loading}
          onClick={handleVerifyOtp}
          className="w-full py-3 rounded-lg bg-blue-600 hover:bg-blue-700
          font-semibold transition disabled:opacity-60"
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </div>
    </div>
  );
}
